import '../../App.scss'
import React, { Component } from 'react'

export default class Community extends Component {
    constructor(props) {
        super(props);
        this.state = {
            content: ['']
        };
    }
    componentDidMount() {
        this.setState({

        })
        // console.log(collection)
    }
    render() {

        return (
            <div className="Community">
                <div className="CommunityBlock">
                    <h2>AHRF<br></br> Facebook Group</h2>
                    <div className="TextBoxColumns">
                        <div className="Thing">
                            <p>1,300+ members! A Great way to meet like minded people who share a passion for discovering and protecting ancient history!</p>
                            <a href="https://www.facebook.com/groups/723774731015622/" target="_blank" rel="nofeferrer">
                                <div className="Register">Join Group</div>
                            </a>
                        </div>
                        <img src="https://lh3.googleusercontent.com/pw/ACtC-3fndY9SIgagJLLQN5aRyQQqQuh7W3er-_FMfqIyJp2XdAcBvPSteEfkuoea-cwTMgsaSNsV9wXZ_KP_ptlI2OwvwSKYDipaRhY1_cqIozsdOYH4RRWtl8xuTgeWtTsRBKYOKxskgQ_OQGdZjecEt3lhyw=s969-no?authuser=0" alt="AHRF star" />
                    </div>
                </div>
                <div className="CommunityBlock">
                    <h2>AHRF<br></br> Email List</h2>
                    <div className="TextBoxColumns">
                        <div className="Thing">
                            <p>A great way to say connected and updated on future events and other AHRF community interests!</p>
                            <a href="https://forms.gle/D4rJsiDdt4rbpVMG7" target="_blank" rel="nofeferrer">
                                <div className="Register">Add me!</div>
                            </a>
                        </div>
                        <img src="https://lh3.googleusercontent.com/pw/ACtC-3etDgawCbKkAbHJqaewyptYFzEQLCpWC_6h8KQjAzGNGylxNqrAycQ66Nc4KF6BNVA2qv3u7soTmMsVdgC_15rLNd51ZW9K3IaWScvuofK6uFxaUNIBvDZKv1uKbMT1HtnTRrz6N0W64bo9r3gT_Ihvwg=s969-no?authuser=0" alt="AHRF star" />
                    </div>
                </div>
                <div className="CommunityBlock">
                    <h2>AHRF<br></br> Slack Gorup</h2>
                    <div className="TextBoxColumns">
                        <div className="Thing">
                            <p>A brand new group! Help us build our community presence on Slack!</p>
                            <a href="https://join.slack.com/t/ancienthistor-1ql5480/shared_invite/zt-ls8ni8lj-XMBGJ6a7A9Z~ywWPdEttwQ" target="_blank" rel="nofeferrer">
                                <div className="Register">Join Group</div>
                            </a>
                        </div>
                        <img src="https://lh3.googleusercontent.com/pw/ACtC-3cgMdT6869YeynrBV4D_mDgXH2L4jJb7phY2HDqFIZGt-i2nx19XWZpFNLrrsV1lWlLFf6ZeabM3_3hCLGAyw2mkJxrHNLnaMMSk72cVIL4F7zyKFTy22wiIghXVkdAQ8Saq7BBROEVGstpXVAMJObHwQ=s969-no?authuser=0" alt="AHRF star" />
                    </div>
                </div>
            </div>
        );
    }
}
